// Mock data for NBA players when the API is unavailable
export const mockNBAPlayers = [
  {
    id: 1,
    firstname: "LeBron",
    lastname: "James",
    age: 39,
    birth: {
      date: "1984-12-30",
      country: "USA"
    },
    nationality: "USA",
    height: "2.06",
    weight: "113",
    team: {
      id: 14,
      name: "Los Angeles Lakers",
      logo: "https://media.api-sports.io/basketball/teams/14.png"
    },
    position: "Small Forward"
  },
  {
    id: 2,
    firstname: "Stephen",
    lastname: "Curry",
    age: 36,
    birth: {
      date: "1988-03-14",
      country: "USA"
    },
    nationality: "USA",
    height: "1.88",
    weight: "84",
    team: {
      id: 11,
      name: "Golden State Warriors",
      logo: "https://media.api-sports.io/basketball/teams/11.png"
    },
    position: "Point Guard"
  },
  {
    id: 3,
    firstname: "Kevin",
    lastname: "Durant",
    age: 35,
    birth: {
      date: "1988-09-29",
      country: "USA"
    },
    nationality: "USA",
    height: "2.08",
    weight: "109",
    team: {
      id: 24,
      name: "Phoenix Suns",
      logo: "https://media.api-sports.io/basketball/teams/24.png"
    },
    position: "Small Forward"
  },
  {
    id: 4,
    firstname: "Giannis",
    lastname: "Antetokounmpo",
    age: 29,
    birth: {
      date: "1994-12-06",
      country: "Greece"
    },
    nationality: "Greece",
    height: "2.11",
    weight: "110",
    team: {
      id: 15,
      name: "Milwaukee Bucks",
      logo: "https://media.api-sports.io/basketball/teams/15.png"
    },
    position: "Power Forward"
  },
  {
    id: 5,
    firstname: "James",
    lastname: "Harden",
    age: 34,
    birth: {
      date: "1989-08-26",
      country: "USA"
    },
    nationality: "USA",
    height: "1.96",
    weight: "100",
    team: {
      id: 16,
      name: "Los Angeles Clippers",
      logo: "https://media.api-sports.io/basketball/teams/16.png"
    },
    position: "Shooting Guard"
  },
  {
    id: 6,
    firstname: "Luka",
    lastname: "Doncic",
    age: 25,
    birth: {
      date: "1999-02-28",
      country: "Slovenia"
    },
    nationality: "Slovenia",
    height: "2.01",
    weight: "104",
    team: {
      id: 8,
      name: "Dallas Mavericks",
      logo: "https://media.api-sports.io/basketball/teams/8.png"
    },
    position: "Point Guard"
  },
  {
    id: 7,
    firstname: "Nikola",
    lastname: "Jokic",
    age: 29,
    birth: {
      date: "1995-02-19",
      country: "Serbia"
    },
    nationality: "Serbia",
    height: "2.11",
    weight: "129",
    team: {
      id: 7,
      name: "Denver Nuggets",
      logo: "https://media.api-sports.io/basketball/teams/7.png"
    },
    position: "Center"
  }
];
